import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { headerData } from '/@/components/crop-monitoring/assets/headerData';
import IconTitleText from '/@/components/crop-monitoring/icon-title-text';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';
import styles from '../styles.module.css';

const HeaderSteps = ({ next, isMobile }) => {
    return (
        <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'
            sx={{ height: { xs: '100%', md: 'auto' } }}
        >
            <Grid item xs={12} sx={{ mb: 2 }}>
                <Title theme={settings.app.theme} className={styles.titleCropMonitoring}>
                    {_('Seguimiento de cultivo')}
                </Title>
            </Grid>
            <Grid item xs={12} sx={{ px: { md: 2 }, pt: { xs: 2, md: 0 } }}>
                <Grid container spacing={isMobile ? 1 : 2} direction='row' justifyContent='space-between'>
                    {headerData.map((hd, key) => {
                        return (
                            <Grid item xs={12} sm={6} lg={3} key={key} sx={{ pb: { xs: 2, md: 0 } }}>
                                <IconTitleText icon={hd.icon} title={hd.title} border text={hd.text} />
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
            {isMobile && (
                <Grid sx={{ p: 2, borderTop: '0.5px solid #E1E1E1', width: '100%' }}>
                    <Button onClick={next} variant='contained'>
                        {_('Comenzar')}
                    </Button>
                </Grid>
            )}
        </Grid>
    );
};

export default HeaderSteps;
